<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    scrollable
  >
    <v-card class="pa-3">
      <v-card-title>
        <h3>{{ title }}</h3>
        <v-spacer />
        <v-btn
          icon
          color="primary"
          @click.native="ok"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text-xs-left">
        <pre>{{ message }}</pre>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    message: null,
    title: null
  }),
  methods: {
    open (message, title) {
      this.dialog = true
      this.message = message
      this.title = title || 'Mensaje'
    },
    ok () {
      this.dialog = false
    }
  }
}
</script>
